require.register("app/graphql/MultiQuery", function(exports, require, module){
  $0
  
});

